class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  static isShortSingleTermQuery(query) {
    const q = query.trim();
    return q.length > 0 && q.length <= 2 && !/\s/.test(q);
  }

  static displaySearchQuery(query) {
    const q = query.trim();
    if (SearchForm.isShortSingleTermQuery(q.replace(/\*$/, '')) && q.endsWith('*')) {
      return q.slice(0, -1);
    }
    return q;
  }

  normalizeSearchQuery(query) {
    const q = query.trim();
    if (!q) return q;
    const base = q.endsWith('*') ? q.slice(0, -1) : q;
    if (!SearchForm.isShortSingleTermQuery(base)) return q;
    return `${base}*`;
  }

  removeNormalizedSearchInput(form) {
    form?.querySelector('input[data-search-normalized-q]')?.remove();
  }

  applySearchQueryNormalization(event) {
    if (!this.input?.form) return false;

    const form = this.input.form;
    if (form.querySelector('input[data-search-normalized-q]')) {
      event?.preventDefault();
      return true;
    }

    const visibleQuery = SearchForm.displaySearchQuery(this.input.value);
    const normalized = this.normalizeSearchQuery(visibleQuery);

    if (normalized === visibleQuery) {
      return false;
    }

    event?.preventDefault();
    this.removeNormalizedSearchInput(form);
    this.input.value = visibleQuery;

    const hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = 'q';
    hidden.value = normalized;
    hidden.setAttribute('data-search-normalized-q', '');
    form.appendChild(hidden);

    const inputName = this.input.getAttribute('name');
    this.input.removeAttribute('name');
    form.submit();
    if (inputName) this.input.setAttribute('name', inputName);

    return true;
  }

  onFormSubmit(event) {
    this.applySearchQueryNormalization(event);
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    this.removeNormalizedSearchInput(this.input?.form);
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
